import axios from 'axios';
import qs from 'qs';
import { Message } from 'element-ui';
import store from '@/store/index';
import destoryVm from '@/utils/destory-popup';
import router from '../router/index';


let requestUrl = [];
let pending = [];
let cancelToken = axios.CancelToken;
let removePending = (ever) => {
  for (let p in pending) {
    if (pending[p].u === ever.url + '&' + ever.method) { // 当当前请求在数组中存在时执行函数体
      pending[p].f(); // 执行取消操作
      pending.splice(p, 1); // 把这条记录从数组中移除
    }
  }
};
let cancelUrl = [];
let conf = {};

// 提供给后台本地调试地址
let remoteUrl = '';
if (process.env.NODE_ENV == 'development') {
  remoteUrl = localStorage.getItem('personUrl');
}
const instance = axios.create(conf);

instance.interceptors.request.use(config => {
  let userToken = localStorage.getItem('userToken');
  config.headers['Content-Type'] = config.headers['Content-Type'] ? config.headers['Content-Type'] : 'application/x-www-form-urlencoded';
  config.headers.Authorization = userToken;
  config.url = `${remoteUrl || ''}/bs${config.url}`;
  if (config.headers['Content-Type'] == 'application/x-www-form-urlencoded') {
    if (!config.data) config.data = {};
    config.data.token = userToken;
    config.data = qs.stringify(config.data);
  }
  if (config.method.toLocaleLowerCase() == 'get') {
    if (!config.params) config.params = {};
    config.params.token = userToken;
  }
  // removePending(config);
  // config.cancelToken = new cancelToken((c) => {
  //     pending.push({ u: config.url + '&' + config.method, f: c });
  // });
  let postData = config.data;
  let contentType = config.headers['Content-Type'].toLocaleLowerCase();
  if (contentType == 'application/json') {
    postData = JSON.stringify(postData);
  }
  if (requestUrl.find(item => item == config.url + postData + config.method)) {
    return Promise.reject();
  } else {
    requestUrl.push(config.url + postData + config.method);
  }
  return config;
});
let isObj = function (v) {
  let obj = Object.prototype.toString.call(v) === '[object Object]';
  return obj;
};
let delRequest = function (config) {
  let requestIndex = requestUrl.findIndex(item => item == config.url + config.data + config.method);
  if (requestIndex >= 0) {
    requestUrl.splice(requestIndex, 1);
  }
  
  console.log(requestUrl, /requestUrl/);
};
instance.interceptors.response.use(res => {
  // if (cancelUrl.find(item => item == res.config.url)) {
  //     removePending(res.config);
  // }
  console.log(res, /res/);
  let { data, headers } = res;
  const mime = headers['content-type'];
  if (/application\/json/i.test(mime)) {
    let arr = ['110021', '110023', '170102', '170002'];
    if (arr.indexOf(res.data.errorCode) != -1) {
      if (!res.config.catchErrBySelf && res.data.errorCode == 110021) {
        Message.error(res.data.errorMsg);
      }
      localStorage.removeItem('userToken');
      store.dispatch('clearPremission');
      destoryVm();
      // router.push('/login');
      delRequest(res.config);
      location.href = '/login';
      return Promise.reject(new Error({ error: '登录失效' }));
    }
    if (!res.data.success) {
      let errorCode = res.data.errorCode;
      if (res.data.errorMsg && !res.config.catchErrBySelf) {
        Message.error(res.data.errorMsg);
      }
      delRequest(res.config);
      return Promise.reject(res.data);
    }
    if (res.data.extraData && isObj(res.data.extraData)) {
      for (let i in res.data.extraData) {
        if (res.data.extraData[i] + '' == 'null') {
          res.data.extraData[i] = '';
        }
      }
    }
    if (res.data.data) {
      if (isObj(res.data.data)) {
        for (let i in res.data.data) {
          if (res.data.data[i] + '' == 'null') {
            res.data.data[i] = '';
          }
        }
      } else if (Array.isArray(res.data.data)) {
        res.data.data.forEach(item => {
          for (let i in item) {
            if (item[i] + '' == 'null') {
              item[i] = '';
            }
          }
        });
      }
    }
  }
  delRequest(res.config);
  return res.data;
}, error => {
  let config = error && error.config;
  if (config) {
    delRequest(config);
  }
  if (error && error.message) {
    Message.error('后台服务异常');
  }
  return Promise.reject(new Error(error));
});

export default instance;



// WEBPACK FOOTER //
// ./src/utils/request.js